export default __webpack_public_path__ + "static/media/IMG-20220516-WA0020[8286].4cff1b59.jpg";